{
  "familyId": "SPR-KLANK-VERDUBBEL",
  "questions": [
    {
      "id": "SPR-KLANK-VERDUBBEL-001",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Wat is de juiste spelling? De ... zit op het dak.",
      "options": ["kat-ten → katten", "ka-ten → katen", "kat-en → katen", "ka-tten → katten"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "katten",
            "syllables": ["kat", "ten"],
            "types": ["closed", "closed"],
            "highlight": [1],
            "label": "kat·ten — de t wordt verdubbeld"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Medeklinker verdubbelen",
            "content": "Bij een korte klank in een open lettergreep verdubbel je de medeklinker. 'Kat' heeft een korte 'a'. In het meervoud: kat → kat-ten (de t wordt verdubbeld om de klank kort te houden).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Kat' heeft een korte 'a'. In het meervoud wordt de 't' verdubbeld: kat-ten → katten. Zonder verdubbeling zou het 'ka-ten' worden, en dan klinkt de 'a' lang (zoals in 'laten'). De verdubbeling houdt de klank kort.",
        "solutionSteps": [
          "'Kat' heeft een korte klank: a",
          "Meervoud: voeg -en toe",
          "Verdubbel de medeklinker: kat → kat-ten",
          "Schrijf: katten"
        ],
        "distractorExplanations": {
          "0": "Goed! De t wordt verdubbeld om de korte klank te behouden: katten.",
          "1": "Zonder verdubbeling wordt het 'ka-ten', en dan klinkt de 'a' lang (zoals in 'laten'). De verdubbeling houdt de klank kort. Onthoud: korte klank → medeklinker verdubbelen.",
          "2": "De verdeling 'kat-en' klopt niet — je moet de medeklinker verdubbelen: 'kat-ten'. Onthoud: bij een korte klank verdubbel je de medeklinker vóór de uitgang.",
          "3": "De verdeling 'ka-tten' klopt niet — de dubbele medeklinker hoort bij de eerste lettergreep: 'kat-ten', niet 'ka-tten'. Onthoud: de eerste lettergreep eindigt op de dubbele medeklinker."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 1 },
          { "id": "spr.wrong-syllable-split", "label": "Verkeerde lettergreepverdeling", "optionIndex": 2 },
          { "id": "spr.wrong-syllable-split", "label": "Dubbele medeklinker bij verkeerde lettergreep", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-002",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Welk woord is FOUT gespeld?",
      "options": ["bommen (van bom)", "netten (van net)", "pennen (van pen)", "boten (van bot)"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Medeklinker verdubbelen",
            "content": "'Bot' heeft een korte 'o'. In het meervoud moet de 't' verdubbeld worden: bot-ten → botten. 'Boten' (zonder verdubbeling) klinkt als 'bo-ten' met een lange 'o' (zoals in 'boten' = schepen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_error_detect",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Boten' is fout als meervoud van 'bot' (been). Het moet 'botten' zijn (met dubbele t). 'Boten' zonder verdubbeling betekent iets anders: schepen! Bommen, netten en pennen zijn correct gespeld.",
        "solutionSteps": [
          "'Bot' heeft een korte 'o'",
          "Meervoud: bot → bot-ten → botten",
          "'Boten' (zonder verdubbeling) = schepen (ander woord!)",
          "De andere woorden zijn correct: bommen, netten, pennen"
        ],
        "distractorExplanations": {
          "0": "'Bommen' is correct: bom → bom-men → bommen. De 'm' wordt verdubbeld om de korte 'o' te behouden.",
          "1": "'Netten' is correct: net → net-ten → netten. De 't' wordt verdubbeld om de korte 'e' te behouden.",
          "2": "'Pennen' is correct: pen → pen-nen → pennen. De 'n' wordt verdubbeld om de korte 'e' te behouden.",
          "3": "Goed! 'Boten' is fout als meervoud van 'bot'. Het moet 'botten' zijn."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.double-consonant-correct", "label": "Correct verdubbeld woord als fout gezien", "optionIndex": 0 },
          { "id": "spr.double-consonant-correct", "label": "Correct verdubbeld woord als fout gezien", "optionIndex": 1 },
          { "id": "spr.double-consonant-correct", "label": "Correct verdubbeld woord als fout gezien", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-003",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je het meervoud van 'kop'?",
      "options": ["kopen", "koopen", "koppen", "kopppen"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "koppen",
            "syllables": ["kop", "pen"],
            "types": ["closed", "closed"],
            "highlight": [1],
            "label": "kop·pen — de p wordt verdubbeld"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korte klank → verdubbelen",
            "content": "'Kop' heeft een korte 'o'. Zonder verdubbeling wordt het 'ko-pen' (lange 'o', zoals in 'kopen' = iets aanschaffen). Met verdubbeling: kop-pen → koppen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_kop",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Kop' heeft een korte 'o'. Verdubbel de 'p': kop-pen → koppen. Zonder verdubbeling wordt het 'kopen' — en dat is een heel ander woord (iets aanschaffen)!",
        "solutionSteps": [
          "'Kop' heeft een korte klank: o",
          "Verdubbel de medeklinker: p → pp",
          "kop-pen → koppen",
          "Check: 'kopen' (zonder verdubbeling) = iets aanschaffen ≠ meervoud van kop"
        ],
        "distractorExplanations": {
          "0": "'Kopen' zonder verdubbeling betekent 'iets aanschaffen' — een heel ander woord! Het meervoud van 'kop' is 'koppen'. Onthoud: korte klank → verdubbelen.",
          "1": "Je dacht waarschijnlijk dat je de klinker verdubbelt: 'koopen'. Maar bij een korte klank verdubbel je de medeklinker, niet de klinker. 'oo' maakt de klank juist lang. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Goed! De p wordt verdubbeld: koppen.",
          "3": "Je verdubbelt de medeklinker maar één keer: 'pp', niet 'ppp'. Onthoud: verdubbeling = twee keer dezelfde letter."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank (kopen ≠ koppen)", "optionIndex": 0 },
          { "id": "spr.vowel-doubled-instead", "label": "Klinker verdubbeld i.p.v. medeklinker", "optionIndex": 1 },
          { "id": "spr.triple-consonant", "label": "Drie medeklinkers i.p.v. twee", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-004",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Bij welk woord hoef je de medeklinker NIET te verdubbelen in het meervoud?",
      "options": ["kat → katten", "boom → bomen", "bom → bommen", "bed → bedden"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lange klank → geen verdubbeling",
            "content": "'Boom' heeft al een lange klank (oo). Bij een lange klank hoef je de medeklinker niet te verdubbelen. Het meervoud is gewoon 'bo-men' → bomen. Bij korte klanken (kat, bom, bed) moet je wél verdubbelen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_exception_long",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Boom' heeft een lange klank (oo). Bij lange klanken hoef je de medeklinker niet te verdubbelen: boom → bo-men → bomen. Bij korte klanken (kat, bom, bed) moet je wél verdubbelen om de klank kort te houden.",
        "solutionSteps": [
          "'Boom' heeft een lange klank: oo",
          "Lange klank → geen verdubbeling nodig",
          "boom → bo-men → bomen",
          "Korte klanken (kat, bom, bed) → wél verdubbelen"
        ],
        "distractorExplanations": {
          "0": "'Kat' heeft een korte 'a' → wél verdubbelen: katten. Onthoud: korte klank = verdubbelen.",
          "1": "Goed! 'Boom' heeft een lange klank → geen verdubbeling: bomen.",
          "2": "'Bom' heeft een korte 'o' → wél verdubbelen: bommen. Onthoud: korte klank = verdubbelen.",
          "3": "'Bed' heeft een korte 'e' → wél verdubbelen: bedden. Onthoud: korte klank = verdubbelen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.double-consonant-for-long-vowel", "label": "Verdubbeling bij lange klank (niet nodig)", "optionIndex": 0 },
          { "id": "spr.double-consonant-for-long-vowel", "label": "Verdubbeling bij lange klank (niet nodig)", "optionIndex": 2 },
          { "id": "spr.double-consonant-for-long-vowel", "label": "Verdubbeling bij lange klank (niet nodig)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-005",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'bal'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["ballen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Medeklinker verdubbelen",
            "content": "'Bal' heeft een korte 'a'. Verdubbel de 'l': bal → bal-len → ballen. Zonder verdubbeling wordt het 'ba-len' (= boos zijn), een heel ander woord!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Bal' heeft een korte 'a'. Verdubbel de 'l': bal-len → ballen. Zonder verdubbeling wordt het 'balen' (= boos zijn)!",
        "solutionSteps": [
          "'Bal' heeft een korte klank: a",
          "Verdubbel de medeklinker: l → ll",
          "bal-len → ballen"
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-006",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "categorize",
      "question": "Sorteer deze meervoudsvormen: moet de medeklinker verdubbeld worden of niet?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Verdubbelen (korte klank)", "Niet verdubbelen (lange klank)"],
        "items": [
          { "text": "kat → katten", "correctCategory": 0 },
          { "text": "boot → boten", "correctCategory": 1 },
          { "text": "bed → bedden", "correctCategory": 0 },
          { "text": "maan → manen", "correctCategory": 1 },
          { "text": "pot → potten", "correctCategory": 0 },
          { "text": "raam → ramen", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Verdubbelen of niet?", "content": "Korte klank → verdubbel de medeklinker: kat → katten, bed → bedden, pot → potten.\nLange klank → niet verdubbelen: boot → boten, maan → manen, raam → ramen.\n\nLuister naar de klinker: kort of lang?", "icon": "lightbulb" } }
      ],
      "conceptId": "consonant_doubling_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Korte klank → verdubbelen: kat → katten, bed → bedden, pot → potten. Lange klank → niet verdubbelen: boot → boten, maan → manen, raam → ramen. De sleutel is luisteren: klinkt de klinker kort of lang?",
        "solutionSteps": [
          "Luister naar de klinker in het enkelvoud",
          "Kort (a, e, i, o, u) → verdubbel de medeklinker",
          "Lang (aa, ee, oo, uu) → niet verdubbelen"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-007",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over medeklinkerverdubbeling waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Het meervoud van 'kat' is 'katen'.", "isTrue": false },
          { "text": "Bij een lange klank hoef je niet te verdubbelen.", "isTrue": true },
          { "text": "Het meervoud van 'bom' is 'bommen'.", "isTrue": true },
          { "text": "'Boten' is het correcte meervoud van 'bot' (been).", "isTrue": false },
          { "text": "Bij 'boom → bomen' verdubbel je de m niet, want de klank is lang.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Verdubbelen of niet?", "content": "Korte klank → verdubbel de medeklinker: kat → katten, bom → bommen, bot → botten.\nLange klank → niet verdubbelen: boom → bomen.\n\nLuister naar de klinker: kort of lang?", "icon": "lightbulb" } }
      ],
      "conceptId": "consonant_doubling_tf",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Korte klank → verdubbelen: kat → katten (niet katen), bom → bommen, bot → botten (niet boten — dat zijn schepen!). Lange klank → niet verdubbelen: boom → bomen (de 'o' is al lang).",
        "solutionSteps": [
          "Stelling 1: Onwaar ✗ — kat → katten (korte a → dubbele t)",
          "Stelling 2: Waar ✓ — lange klank = geen verdubbeling",
          "Stelling 3: Waar ✓ — bom → bommen (korte o → dubbele m)",
          "Stelling 4: Onwaar ✗ — bot → botten (boten = schepen!)",
          "Stelling 5: Waar ✓ — boom → bomen (lange oo → geen verdubbeling)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-008",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "error_spotting",
      "question": "Zoek de spelfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De katen spelen in de tuin. Ze jagen op een muis en springen over de heken. Eén kat vangt een vlinder in zijn poten.",
        "errors": [
          {
            "word": "katen",
            "position": 1,
            "correction": "katten",
            "explanation": "Korte 'a' in 'kat' → verdubbel de t: kat-ten → katten."
          },
          {
            "word": "heken",
            "position": 14,
            "correction": "hekken",
            "explanation": "Korte 'e' in 'hek' → verdubbel de k: hek-ken → hekken."
          },
          {
            "word": "poten",
            "position": 20,
            "correction": "potten",
            "explanation": "Als meervoud van 'pot' (niet 'poot'): korte 'o' → verdubbel de t: pot-ten → potten."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Verdubbelen bij korte klank", "content": "Bij een korte klank verdubbel je de medeklinker:\nkat → katten (niet katen)\nhek → hekken (niet heken)\npot → potten (niet poten — dat zijn dierenpoten!)", "icon": "lightbulb" } }
      ],
      "conceptId": "consonant_doubling_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten: 'katen' moet 'katten' zijn (korte a → dubbele t), 'heken' moet 'hekken' zijn (korte e → dubbele k), 'poten' moet 'potten' zijn als meervoud van pot (korte o → dubbele t). Let op: 'poten' bestaat wél, maar dan als meervoud van 'poot' (dierenpoten)!",
        "solutionSteps": [
          "Fout 1: katen → katten (korte 'a' → dubbele t)",
          "Fout 2: heken → hekken (korte 'e' → dubbele k)",
          "Fout 3: poten → potten (korte 'o' → dubbele t)",
          "Correct: spelen, jagen, springen, vangt ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-009",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "matching",
      "question": "Koppel elk enkelvoud aan het juiste meervoud.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "kat", "right": "katten" },
          { "left": "boom", "right": "bomen" },
          { "left": "bed", "right": "bedden" },
          { "left": "maan", "right": "manen" },
          { "left": "pot", "right": "potten" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Korte of lange klank?", "content": "Korte klank → verdubbel: kat → katten, bed → bedden, pot → potten.\nLange klank → niet verdubbelen: boom → bomen, maan → manen.\nLuister naar de klinker!", "icon": "lightbulb" } }
      ],
      "conceptId": "consonant_doubling_matching",
      "variantIndex": 9,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Korte klank → verdubbelen: kat → katten, bed → bedden, pot → potten. Lange klank → niet verdubbelen: boom → bomen, maan → manen. De sleutel is luisteren naar de klinker in het enkelvoud.",
        "solutionSteps": [
          "Luister naar de klinker: kort of lang?",
          "Kort (a, e, o) → verdubbel: katten, bedden, potten",
          "Lang (oo, aa) → niet verdubbelen: bomen, manen"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}